/* ============================================================
   BASICARE — 商品ページの操作

   カンプ product.html のインラインJSを移植しました。
     ・ギャラリーのサムネイル切り替え
     ・数量ステッパー
     ・スティッキー購入バー（購入ボタンが画面外に出たら表示）

   カンプでは要素をページ全体から1つだけ拾っていましたが、
   数量ステッパーはフォームごとに存在しうるため、フォーム単位に
   スコープを切って動かします。
   ============================================================ */
(function () {
  /* ---- ギャラリー ---- */
  function initGallery(gallery) {
    if (gallery.dataset.bound) return;
    gallery.dataset.bound = '1';

    var mains = gallery.querySelectorAll('.gal-main img');
    var thumbs = gallery.querySelectorAll('.gal-thumbs button');
    if (!mains.length || !thumbs.length) return;

    function select(index) {
      mains.forEach(function (m, j) {
        m.classList.toggle('on', j === index);
      });
      thumbs.forEach(function (t, j) {
        var on = j === index;
        t.classList.toggle('on', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (b, i) {
      b.addEventListener('click', function () {
        select(i);
      });
    });
    select(0);
  }

  /* ---- 数量ステッパー ---- */
  function initQty(qty) {
    if (qty.dataset.bound) return;
    qty.dataset.bound = '1';

    var input = qty.querySelector('input[name="quantity"]');
    var dec = qty.querySelector('[data-dec]');
    var inc = qty.querySelector('[data-inc]');
    if (!input) return;

    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var max = parseInt(input.getAttribute('max'), 10) || 99;

    function clamp(v) {
      v = parseInt(v, 10);
      if (isNaN(v)) v = min;
      return Math.max(min, Math.min(max, v));
    }
    if (dec) {
      dec.addEventListener('click', function () {
        input.value = clamp(input.value - 1);
      });
    }
    if (inc) {
      inc.addEventListener('click', function () {
        input.value = clamp(input.value * 1 + 1);
      });
    }
    input.addEventListener('change', function () {
      input.value = clamp(input.value);
    });
  }

  /* ---- スティッキー購入バー ----
     購入ボタンが画面上部より外へ出たら表示します。
     下方向へ出ている（まだ読み進めていない）ときは出しません。 */
  function initStickyBar(bar) {
    if (bar.dataset.bound) return;
    bar.dataset.bound = '1';

    var anchor = document.querySelector('.buy-actions');
    if (!anchor || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    io.observe(anchor);
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('.gallery').forEach(initGallery);
    scope.querySelectorAll('.qty').forEach(initQty);
    scope.querySelectorAll('.stickybar').forEach(initStickyBar);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
